import React from "react";

export default function LinkIlona (){
  return (
  <div className="gitHub">
    <span>This project was coded by Ilona Mohilnikova and is open-sourced on 
        <a
          
          href="https://github.com/Velcipher/dictionary-react"
          target="_blank"
          rel="noreferrer"
          > GitHub </a>
        and hosted on
        <a
          href="https://lucky-crostata-b0319d.netlify.app/"
          target="_blank"
          rel="noreferrer"
          > Netlify </a></span>
  </div>
  )
}